import Spinner from 'components/spinner';
import { ComponentPropsWithRef, FC, forwardRef } from 'react';

type TButtonVariant = 'primary' | 'secondary' | 'tertiary' | 'link';

interface IProps extends ComponentPropsWithRef<'button'> {
  label: any;
  buttonVariant?: TButtonVariant;
  isLoading?: boolean;
  labelClassName?: string;
}

const Button: FC<IProps> = forwardRef<HTMLButtonElement, IProps>(
  ({ label = 'Button', buttonVariant = 'primary', className = '', isLoading, type = 'button', labelClassName = '', ...props }, ref) => {
    return (
      <button ref={ref} type={type} className={['button-container', buttonVariant, className].join(' ')} {...props}>
        {isLoading ? (
          <div className='w-full flex justify-center items-center'>
            <Spinner className={['!w-4 !h-4', buttonVariant === 'primary' ? '!text-white' : ''].join(' ')} />
          </div>
        ) : (
          <span className={['relative', labelClassName].join(' ')}>{label}</span>
        )}
      </button>
    );
  }
);

Button.displayName = 'Button';

export default Button;
